/* eslint-disable i18next/no-literal-string -- type definitions */
export const AttributeOperation = {
    READ: 'READ',
    CREATE: 'CREATE',
    UPDATE: 'UPDATE',
    DELETE: 'DELETE',
} as const
export type AttributeOperation = typeof AttributeOperation[keyof typeof AttributeOperation]

export const ALL_OPERATIONS: readonly AttributeOperation[] = [
    AttributeOperation.READ,
    AttributeOperation.CREATE,
    AttributeOperation.UPDATE,
    AttributeOperation.DELETE,
]
/* eslint-enable i18next/no-literal-string */
